import { connect } from "pwa-helpers/connect-mixin.js";
import { store } from "../inspx-store.js";
import { DdlInput } from "./ddl-input";

export class DynamicDDL extends connect(store)(DdlInput) {
	render() {
		this.generateOptions();
		return super.render();
	}

	generateOptions() {
		if (typeof this._func === "function") {
			const v = this._func(this.__insp, this.localContext);

			this.options = v;
		}
	}

	firstUpdated() {
		this.label = (this.prop.title.toString() + (this.prop.required ? "*" : ""));
		this._value = "";
	}

	_initFunc() {
		const eval2 = eval;
		//this is workaround for rollup (https://github.com/rollup/rollup/wiki/Troubleshooting#avoiding-eval)
		this.__f = this.prop.func ? eval2("(" + this.prop.func + "\n)") : null;
	}

	_func(insp, localContext) {
		let res = [];
		try {
			if (this.__f === undefined) {
				this._initFunc();
			}
			res = this.__f(insp, localContext);
		} catch (e) {
			//console.warn(e);
		}
		return res;
	}

	getAdjustedValue(v) {
		return v === "" ? undefined : v;
	}

	static get properties() {
		return {
			...super.properties,
			... {
				_value: { type: String },
				localContext: { type: Object },
				prop: { type: Object },
			}
		};
	}

	stateChanged(state) {
		this.__insp = state.inspection.current || (state.inspection.remote ? state.inspection.remote.inspection : null);
		this.generateOptions();
	}
}

window.customElements.define("inspx-fnddl-field", DynamicDDL);
